<template>

  <monitor-layout 
    v-bind:monitor_filter="monitor_filter" 
    v-bind:title="title" 
    v-on:updateFilters="_updateFilters"
    v-on:updateFilterPreview="_updateFilterPreview"
    v-on:updateDates="_updateDates" >
    <template v-slot:default="slotProps">
        <b-loading :is-full-page="isFullPage" :active.sync="showLoader"></b-loading>
        <div>
            <div class="chart-row">
               <!-- <HorizontalBarChartBox :subLabels="{measurement: ['count', 'percent']}" subLabelType="singleLabel" chartTitle="Completed Conversations" :chartData="horizontalChartData"> </HorizontalBarChartBox>-->
                <DoughnutChartBox chartTitle="Conversions" :chartData="conversionsDoughnutChart"> </DoughnutChartBox>
                <DoughnutChartBox chartTitle="Conversations" :chartData="conversationsDoughnutChart"> </DoughnutChartBox>
                <!--<LineChartBox :subLabels="{type: ['complete', 'partial', 'bounce'], measurement: ['count', 'percent']}" subLabelType="twoSublabels" chartTitle="Conversations" :chartData="conversationsChart"> </LineChartBox>-->
            </div>
            <div class="chart-row">
                  <VerticalBarChartBox chartSubtitle = "Drop-off at each scene" chartTitle="Story engagement" :chartData="sceneEngagementChart"> </VerticalBarChartBox>
                <template v-if= "leadFormsIncluded">
                    <DoughnutChartBox chartTitle="Known Visitors" :chartData="visitorIdentityDoughnutChart"> </DoughnutChartBox>
                    <!--<LineChartBox :subLabels="{type: ['known', 'anonymous'],measurement: ['count', 'percent']}" subLabelType="twoSublabels" chartTitle="Contacts" :chartData="visitorIdentityChart"> </LineChartBox>-->
                </template>
                <template  v-if = "paymentsIncluded">
                    <LineChartBox :subLabels="{measurement: ['count', 'value']}" subLabelType="singleLabel" chartTitle="Transaction volume" :chartData="transactionVolumeChart"> </LineChartBox>
                </template>
            </div>
            <div class="chart-row tiles">
                <div class="tile">
                    <label>Average Impression</label>
                    <p>{{averageImpressions}}</p>
                </div>
                <div class="tile">
                    <label>Average Duration</label>
                    <p>{{`${averageDuration}s`}}</p>
                </div>
                <div v-if = "videosIncluded" class="tile">
                    <label>Average Media Engagement</label>
                    <p>{{`${_averageVideoEngagement}s`}}</p>
                </div>
                <div v-if = "leadFormsIncluded" class="tile">
                    <label>Known/Annoynmous</label>
                    <p>{{`${knownCount}/${anonymousCount}`}}</p>
                </div>
                <div v-if = "paymentsIncluded" class="tile">
                    <label>Transactions (Count/Value)</label>
                    <p>{{`${transactionCount}/${transactionValue}`}}</p>
                </div>
            </div>
            <ViewDetails v-if = "_dataExists(userDetails)":columnOrder= "columnOrder" :userDetails="userDetails"/></ViewDetails>
        </div>
    </template>
  </monitor-layout>
</template>
<script>
import MonitorLayout from './common/layout/MonitorLayout';
import monitorMixins from 'SrcRoot/mixins/monitor_mixins';
import { isEmpty, isEqual, cloneDeep, startCase } from "lodash";
import ViewDetails from './common/partials/ViewDetails';
import DoughnutChartBox from './common/chartbox/DoughnutChartBox';
import LineChartBox from './common/chartbox/LineChartBox';
import VerticalBarChartBox from './common/chartbox/VerticalBarChartBox';
import HorizontalBarChartBox from './common/chartbox/HorizontalBarChartBox';
import moment from 'moment';
import EventBus from "@/utils/event-bus";

export default {
    name: "Dashboard",
    mixins: [
        monitorMixins
    ],
    components: {
        'monitor-layout': MonitorLayout,
        ViewDetails,
        DoughnutChartBox,
        LineChartBox,
        VerticalBarChartBox,
        HorizontalBarChartBox
    },
    mounted() {
        this.$nextTick(() => { 
            this._setup();
            this.refreshSetInterval = setInterval(() => {
                this._refreshVisitorData();
            }, 30000); // Refresh visitor data every 30 seconds
           
        }); 
    },
    beforeDestroy() {
        clearInterval(this.refreshSetInterval); 
    },
    data() {
        return {
            refreshSetInterval:"",
            conversionData: {
              labels: ['Full', 'Partial', 'None'],
              datasets: [{
                category:'percent',
                data: [10, 20, 30],
              },
              {
                category:'count',
                data: [20, 25, 30],
              }]
            }, // doughnut
            horizontalChartData: {
                labels: [''],
                datasets: {
                    'percent':[   
                        {label: 'Complete',data: [45]},
                        {label: 'Partial',data: [20]},
                        {label: 'Bounce',data: [35]},
                    ],
                    'count':[ 
                        {label: 'Complete',data: [30],},
                        {label: 'Partial',data: [15]},
                        {label: 'Bounce',data: [60]
                        },
                    ]
                },
                category:"count"
            }, // horizontal stacked

            totalDurationByDay:{}, // to cacluate average duration
            averageDuration:"", // by day by user
            totalImpressionsByDay:{}, // to cacluate average impressions
            averageImpressions:0, // by day by user
            sceneEngagement:{}, // campaing engagement
            sceneEngagementChart:{},

            // one of the 4 depending on what the campaign includes
            mediaEngagement:{}, // media if present, vertical bar 25%, 50%, 75%, 100%
            mediaEngagementChart:{},
           
            responses:{}, // no answer, answered all 8, 7, 6, 5, 4, 3, 2 1,
            responsesChart:{},
            
            transactionCount:0,
            transactionValue:0,
            knownCount:0,
            anonymousCount:0,

            // add dynamic - averageMediaDuration, totalTransactions, transactionsValue, completedSurveys, annoynmous/known

            // for reference
            /*
             horizontalChartData: { // non stacked
              labels: [''],
              datasets: [
                {
                  sublabel: 'Berries',
                  label: '10%',
                  data: [10],
                },
                {
                  sublabel: 'Peaches',
                  label: '20%',
                  data: [20],
                },
                {
                  sublabel: 'Mellons',
                  label: '60%',
                  data: [60],
                },
                
              ]
            },
            verticalBarChartData: {
                    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
                    legendColor:['#f87979', '#7acbf9', '#7af9bf', '#f9c87a', '#bf7af9', '#f97a7a'],
                    datasets: [
                      {
                        label: 'Data One',
                        //backgroundColor: ['#f87979', '#7acbf9', '#7af9bf', '#f9c87a', '#bf7af9', '#f97a7a'],
                        data: [70, 20, 12, 39, 3, 40]
                      }
                    ]
                  },*/

        }  
    },
    computed: {
        component_name() {
            return 'Dashboard: ';
        },
    },
    methods: {
        initLocalData() {
            this.totalDurationByDay={}; 
            this.totalImpressionsByDay={}; // to calcua
            this.sceneEngagement = {};

            this.conversions={};
            this.conversations={};
            this.mediaEngagement = {};
            this.responses = {};
            this.visitorsByIdentity = {}
            this.transactionVolume = {};
        },

        updateSceneEngagementChart() {
            const sceneEngagement = this.sceneEngagement;
            this.$set(this, 'sceneEngagementChart', {});
            //const labels = Array.from({ length: this.sceneCountInCampaign }, (_, i) => i);
            const labels = Array.from({ length: this.sceneCountInCampaign }, (_, i) => i + 1);
            this.$set(this.sceneEngagementChart, 'labels', labels);
            
            // add all scene counts across dates and fill missing scene (with 0)
            const result = {};

            for (const date in sceneEngagement) {
                for (let i = 1; i <= this.sceneCountInCampaign; i++) {
                  const key = i.toString();
                  const value = sceneEngagement[date][key] || 0;
                  result[key] = (result[key] || 0) + value;
                }
            }
          
            const data = Object.values(result); // result is an object, extract the values corresponding to each scene of {1: 4, 2: 1, 3: 2, 4: 5, 5: 0, 6: 2, 7: 0, 8: 1}

            this.$set(this.sceneEngagementChart, 'datasets', [{data: data}]);
        },

        updateAverageDuration() {
            let totalDuration= 0;
            let totalVisitors= 0;
            
            for (const date in this.totalDurationByDay) {
                const durationCount = this.totalDurationByDay[date] || 0;
                const visitorCount = this.visitorsEachDay[date] || 0;
                totalDuration += durationCount;
                totalVisitors += visitorCount;
            }
            this.averageDuration = totalVisitors == 0? 0: Number((totalDuration/totalVisitors).toFixed(1));
        },

        updateAverageImpressions() {
            let totalImpressions= 0;
            let totalVisitors= 0;
            
            for (const date in this.totalImpressionsByDay) {
                const impressionCount = this.totalImpressionsByDay[date] || 0;
                const visitorCount = this.visitorsEachDay[date] || 0;
                totalImpressions += impressionCount;
                totalVisitors += visitorCount;
            }
            this.averageImpressions = totalVisitors == 0? 0: Number((totalImpressions/totalVisitors).toFixed(1));
            
        },

        updateTransactionCountValue() {
            this.transactionValue = 0;
            this.transactionCount = 0;
            const {datasets} = this.transactionVolumeChart;
            for (const dataset of datasets) {
                let total = dataset.data.reduce((acc, current) => acc + current, 0);
                //console.log(dataset.category, total);
                if (dataset.category == 'value') this.transactionValue = Number(total.toFixed(2));
                else this.transactionCount= total
            }
        },

        updateKnownAnnoynmoysCountOld() {
            const {datasets} = this.visitorIdentityChart;
            let knownCount = 0;
            let anonymousCount = 0; 
            for (const dataset of datasets) {
                if (dataset.category === "known count") {
                    knownCount += dataset.data.reduce((sum, value) => sum + (value !== undefined ? value : 0), 0); // use nullish operator - returns the right-hand operand when the left-hand operand is null or undefined,
                } else if (dataset.category === "anonymous count") {
                    anonymousCount += dataset.data.reduce((sum, value) => sum + (value !== undefined ? value : 0), 0);
                }
            }
            this.knownCount = knownCount;
            this.anonymousCount = anonymousCount;
        },


        updateKnownAnnoynmoysCount() {
            
            let knownCount = 0;
            let anonymousCount = 0; 
           
            for (const date in this.conversations) {
                knownCount = knownCount + this.visitorsByIdentity[date]['known'];
                anonymousCount =anonymousCount + this.visitorsByIdentity[date]['anonymous'];
            }
            /*for (const dataset of datasets) {
                if (dataset.category === "known count") {
                    knownCount += dataset.data.reduce((sum, value) => sum + (value !== undefined ? value : 0), 0); // use nullish operator - returns the right-hand operand when the left-hand operand is null or undefined,
                } else if (dataset.category === "anonymous count") {
                    anonymousCount += dataset.data.reduce((sum, value) => sum + (value !== undefined ? value : 0), 0);
                }
            }*/
            this.knownCount = knownCount;
            this.anonymousCount = anonymousCount;
        },

        fillDayRange() {
            const dateRange = this._createDateRange();
            for (const date of dateRange) {
                if (isEmpty(this.visitorsByIdentity[date])) this.visitorsByIdentity[date] = {'anonymous':0, 'known':0};
                if (isEmpty(this.transactionVolume[date])) this.transactionVolume[date] = {'count':0, 'value':0};
                if (isEmpty(this.conversations[date])) this.conversations[date] = {'bounce':0, 'partial':0, 'complete':0};
                if (isEmpty(this.conversions[date])) this.conversions[date] = {'none':0, 'partial':0, 'final':0}
            }
            this.visitorsByIdentity = this._sortInDescendingOrderByDate(this.visitorsByIdentity);
            this.transactionVolume = this._sortInDescendingOrderByDate(this.transactionVolume);
            this.conversations = this._sortInDescendingOrderByDate(this.conversations);
            this.conversions = this._sortInDescendingOrderByDate(this.conversions);  
        },

        updateDashboardSummaryData() { 
            this.initLocalData();
            //this._initVisitorsByDay(); // visitorsEachDay made a computed property
           
            const filteredVisitors = this._filterVisitors(); 
            for (const visitor of filteredVisitors) { // visitor session (same user will have two different objects)
                const { 
                    contacts: contacts, 
                    total_bot_impressions: visit_impressions, 
                    total_conversation_duration: visit_duration,
                    conversation_bounces: visit_bounce, 
                    conversion:visit_conversions,  // array of objects - since a campaign can have multiple conversion hooks
                    created_at,
                    transactions,
                    responses,
                    impressions } = visitor;

                const date = moment(created_at).format('YYYY-MM-DD');

                // to calculate average impressions
                if (impressions.length) {
                    if (!this.totalImpressionsByDay[date]) this.totalImpressionsByDay[date] = impressions.length;
                    else this.totalImpressionsByDay[date] += impressions.length;

                    if (!this.sceneEngagement[date]) this.sceneEngagement[date] = {};
                    const lastScnOrder = impressions.reduce((maxOrder, impression) => Math.max(maxOrder, impression.scnOrder), -1);
                    if (lastScnOrder != -1) {
                        if (!this.sceneEngagement[date][lastScnOrder+1]) this.sceneEngagement[date][lastScnOrder+1] = 1;
                        else this.sceneEngagement[date][lastScnOrder+1] += 1;
                    }
                    
                } else { // legacy support - remove it later on - to do
                    if (!this.totalImpressionsByDay[date]) this.totalImpressionsByDay[date] = visit_impressions;
                    else this.totalImpressionsByDay[date] = this.totalImpressionsByDay[date] + visit_impressions;

                    if (!this.sceneEngagement[date]) this.sceneEngagement[date] = {};
                    if (!this.sceneEngagement[date][visit_impressions]) this.sceneEngagement[date][visit_impressions] = 1;
                    else this.sceneEngagement[date][visit_impressions] += 1;
                }
           

                // to calculate average duration
                if (!this.totalDurationByDay[date]) this.totalDurationByDay[date] = Number(visit_duration);
                else this.totalDurationByDay[date] = this.totalDurationByDay[date] + Number(visit_duration);

                this._updateConversations(date, visit_bounce, impressions); // will fillDayRange if this visitor had no conversations
                this._updateConversions(date, visit_conversions); // will fillDayRange if this visitor had no conversations

                if (this.paymentsIncluded) {
                    for (const transaction of transactions) {
                        const {type, productPrice, paymentMethod, success} = transaction;
                        if (type == 'processingResult') this._updateTransactionVolume(productPrice, success, date); 
                    }
                }
                if (this.leadFormsIncluded) this._updateVisitorIdentity(date, contacts);
            }

            this.fillDayRange();
            this._updateConversionsDoughnutChart();
            //this._updateConversationsChart();
            this._updateConversationsDoughnutChart();
            this.updateSceneEngagementChart();
            this.updateAverageImpressions();
            this.updateAverageDuration();

            if (this.leadFormsIncluded) {
                //this._updateVisitorIdentityChart();
                this._updateVisitorIdentityDoughnutChart();
                this.updateKnownAnnoynmoysCount();
            } 
            if (this.paymentsIncluded) { 
                this._updateTransactionVolumeChart(); 
                this.updateTransactionCountValue();
            }

        },

        updateChartData() { // called from visitorsData watcher in monitor_mixin
            //console.log('updating dashboard data');
            this.updateDashboardSummaryData();
        }
    },
}
</script>
<style lang="scss" scoped>
@import "SrcRoot/modules/Campaign/components/monitor/scss/monitor.scss";
.chart-row {
    flex-wrap:wrap;
    &.tiles {
        width:100%;
    }
}


</style>
